import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestSurgicalOrderDecorator } from 'main/decorators/prepare-api-request-surgical-order-decorator/prepare-api-request-surgical-order-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import SurgicalOrderRecommendationService from 'presentation/contexts/services/surgical-order-recommendation-service'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRecommendationRepository } from 'repository/repositories/surgical-order-recommendation/surgical-order-recommendation-repository'
import { RemoteGetProceduresRecommendations } from 'service/usecases/surgical-order-recommendation/remote-get-procedures-recommendations'

export default function makeSurgicalOrderRecommendationService() {
  const apiSurgicalOrder = new ApiClientImplementation()

  const apiSurgicalOrderRepository =
    new PrepareApiRequestSurgicalOrderDecorator(
      makeLocalStorageAdapter(),
      new ApiRepository(apiSurgicalOrder)
    )

  const surgicalOrderRecommendationRepository =
    new SurgicalOrderRecommendationRepository(apiSurgicalOrderRepository)

  const getProceduresRecommendations = new RemoteGetProceduresRecommendations(
    surgicalOrderRecommendationRepository
  )

  return new SurgicalOrderRecommendationService({
    getProceduresRecommendations
  })
}
